import * as React from "react";

function SvgComponent(props) {
  return (
    <svg fill="#000000" width={39.581} height={40.88} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
	 viewBox="0 0 512 512">
    <g>
      <g>
        <path d="M350.761,255.378l141.375-141.375c25.954-25.954,25.954-68.185,0-94.139C479.565,7.29,462.848,0.366,445.067,0.366
          c-17.781,0-34.496,6.924-47.069,19.497L256.622,161.238L95.383,0L1.244,94.139l161.238,161.238L53.388,364.472l-22.822,63.064
          L0,512l84.463-30.566l63.064-22.822l109.094-109.094L417.86,510.756L512,416.617L350.761,255.378z M419.49,41.357
          c6.832-6.832,15.915-10.594,25.576-10.594s18.745,3.763,25.577,10.594c14.103,14.103,14.103,37.05,0,51.152l-29.27,29.27
          l-51.152-51.153L419.49,41.357z M143.666,193.575l-18.816-18.816l27.662-27.662l-21.493-21.493l-27.662,27.662L84.541,134.45
          l27.662-27.662L90.71,85.293l-27.662,27.662L44.23,94.139l51.153-51.153l139.745,139.745l-51.153,51.153l-18.816-18.816
          l27.662-27.662l-21.493-21.493L143.666,193.575z M50.658,461.342l3.644-10.071l6.427,6.427L50.658,461.342z M92.291,446.275
          l-26.567-26.567l6.96-19.233l38.84,38.84L92.291,446.275z M235.13,328.025l-95.956,95.954l-51.152-51.152l143.024-143.024
          l47.07-47.07l90.612-90.612l51.153,51.153L286.22,276.934L235.13,328.025z M399.045,448.953l27.662-27.662l-21.493-21.493
          l-27.662,27.662l-18.816-18.816l27.662-27.662l-21.493-21.493l-27.662,27.662l-18.816-18.816l27.662-27.662l-21.493-21.493
          l-27.662,27.662l-18.816-18.816l12.616-12.62l38.534-38.534l139.745,139.745l-51.152,51.153L399.045,448.953z"/>
      </g>
    </g>
</svg>
  );
}

export default SvgComponent;